// Generated by CoffeeScript 1.12.7
(function() {
  module.exports = {
    Disconnected: 1,
    Preceding: 2,
    Following: 4,
    Contains: 8,
    ContainedBy: 16,
    ImplementationSpecific: 32
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/xmlbuilder/lib/DocumentPosition.js
// module id = 1012
// module chunks = 0